import { Route, Routes, Navigate } from "react-router-dom";
import { Content } from "../layout/Content";
import { Header } from "../layout/Header";
import { Studio } from "../pages/Studio";
import { SignAsUser } from "../pages/SignAsUser";
import { Home } from "../pages/Home";
import { InitialSettings } from "../pages/InitialSettings";
import { StudioFolder } from "../pages/StudioFolder";
import { Dashboard } from "../pages/Dashboard";
import { Radios } from "../pages/Radios";
import { Site } from "../pages/Site";
import { WhatsApp } from "../pages/WhatsApp";
import { SocialNetwork } from "../pages/SocialNetwork";
import { Financial } from "../pages/Financial";
import { NewArt } from "../pages/NewArt";
import { NewDistribution } from "../pages/NewDistribuition";
import { AccountSettings } from "../pages/AccountSettings";
import { WithoutAccess } from "../pages/WithoutAccess";
import { Notification } from "../pages/Notification";
import { NotificationId } from "../pages/NotificationId";
import { findToken } from "../firebase";
import { useCallback, useEffect } from "react";
import { useMutation } from "react-query";
import { setTokenCloudMessaging } from "../services/company";
import { useAuth } from "../hooks/useAuth";

export function RootRoutes() {
  const { user } = useAuth();
  const handleSetToken = useMutation(setTokenCloudMessaging, { retry: 2 });

  const handleTokenCloudMessaging = useCallback(async () => {
    const token = await findToken();

    if (token) {
      await handleSetToken.mutateAsync(token);
    }
  }, [handleSetToken]);

  useEffect(() => {
    handleTokenCloudMessaging();
    window.Amplifiqueme = {};
    window.Amplifiqueme.onLoad = () => {
      window.Amplifiqueme.identify(
        {
          email: user.email, //Tipo: Email. Campo obrigatório. É o identificador chave do usuário dentro da plataforma
          created_at: new Date().getTime(), //Tipo: Timestamp. Opcional. (caso não utilize, remova a declaração ou defina como undefined). Campo de definição da Data de Criação do Usuário em sua Base.
          name: user.name, //Opcional. Nome do Usuário.
          company: user.companyName, //Opcional. Para definir o nome da Empresa do usuário.
          // phone: '+5542999999999'//Tipo: Celular(Formatio E.164). Opcional. Para definir o celular do usuário.
        },
        true
      );
    };
    if (window.clarity) {
      window.clarity("set", "userName", user.name);
      window.clarity("set", "userEmail", user.email);
      window.clarity("set", "companyId", user.companyId);
      window.clarity("set", "companyName", user.companyName);
      window.clarity("set", "cnpj", user.companyDocument);
      window.clarity(
        "identify",
        user.email,
        user.companyId,
        user.id,
        user.companyName
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Header>
      <Content>
        <Routes>
          <Route path="/" element={<Navigate to={"/dashboard"} />} />
          <Route path="/home" element={<Home />} />
          <Route path="/initial-settings" element={<InitialSettings />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="/financial" element={<Financial />} />
          <Route path="/radios" element={<Radios />} />
          <Route path="/site" element={<Site />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/studio/:id" element={<StudioFolder />} />
          <Route path="/studio/:id/new-art" element={<NewArt />} />
          <Route
            path="/studio/:id/new-distribution"
            element={<NewDistribution />}
          />
          <Route path="/notification" element={<Notification />} />
          <Route path="/notification/:id" element={<NotificationId />} />
          <Route path="sign-as-user/:token" element={<SignAsUser />} />
          <Route path="/social-network" element={<SocialNetwork />} />
          <Route path="/whatsapp" element={<WhatsApp />} />
          <Route path="/withoutAccess" element={<WithoutAccess />} />
        </Routes>
      </Content>
    </Header>
  );
}
